import { CardType, CategoryType } from 'types/deck'

import { alpha } from 'redux/deck/helpers/sorting'

type Options = {
  stopAtSetCode?: boolean
  includeAllCategories?: boolean
}

export const deckToString = (
  input: Array<CardType>,
  categories: Record<string, CategoryType>,
  options?: Options,
): string => {
  const cards = input.sort(alpha)
  const lines = cards.map(card => cardToString(card, categories, options))

  return lines.join('\n')
}

export const cardToString = (card: CardType, categories: Record<string, CategoryType>, options?: Options): string => {
  if (!card.id) return ''

  const setCode = card.setCode ? `(${card.setCode})` : ''
  const collectorNumber = card.superTypes?.includes('Basic') ? card.collectorNumber : ''
  const foilStatus = card.modifier === 'Foil' ? '*F*' : card.modifier === 'Etched' ? ' *E*' : ''
  const categoryInfo = getCategoryInfo(card, categories, options?.includeAllCategories)
  const colorLabelInfo = card.colorLabel.name ? ' ^' + card.colorLabel.name + ',' + card.colorLabel.color + '^' : ''
  const isCustomCard = card.customCard ? '#CustomCard' : ''

  if (options?.stopAtSetCode) return `${card.qty}x ${card.name} ${setCode}`

  return `${card.qty}x ${card.name} ${setCode} ${collectorNumber} ${foilStatus} ${categoryInfo} ${colorLabelInfo} ${isCustomCard}`
    .replace(/\s\s+/g, ' ') // Replace any consecutive double spaces with single space
    .trim()
}

export const getCategoryInfo = (
  card: CardType,
  categories: Record<string, CategoryType>,
  includeAllCategories?: boolean,
): string => {
  if (!card.categories.length) return ''
  if (!includeAllCategories && card.categories[0] === card.typeCategory) return ''

  const categoryStrings = card.categories.map(categoryName => {
    const category = categories[categoryName]

    if (!category) return categoryName

    let output = categoryName

    if (category.isPremier) output += '{top}'
    if (!category.includedInDeck) output += '{noDeck}'
    if (!category.includedInPrice) output += '{noPrice}'

    return output
  })

  return `[${categoryStrings.join(',')}]`
}
